import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface AuthGuardProps {
    children: React.ReactNode;
}

/**
 * Protects routes that require care staff authentication.
 * Redirects to /login if not authenticated or role != 'care'.
 */
export function AuthGuard({ children }: AuthGuardProps) {
    const { user, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-900">
                <div className="flex flex-col items-center gap-4">
                    <div className="h-10 w-10 rounded-full border-3 border-brand-500 border-t-transparent animate-spin" />
                    <p className="text-sm text-neutral-500">Wird geladen…</p>
                </div>
            </div>
        );
    }

    if (!user || user.role !== 'care') {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
}
